<template>
  <div>
    <div style="background-color: #f4f8fa;" class="mini-spacer bg-extra-light">
      <v-container>
        <!-- -----------------------------------------------
            Start Portfolio Text
        ----------------------------------------------- -->
        <v-row justify="center">
          <v-col cols="12" sm="10" md="9" lg="7">
            <div class="text-center">
              <h4 style="font-size: 36px;
  				margin: 20px 0 15px;" class="ui-title font-weight-bold">Tipos de negocios</h4>
              <h5>
                Tenemos módulos especializados para cada tipo de negocio, con un equipo de soporte deseando ayudarte con cualquier problema
              </h5>
            </div>
          </v-col>
        </v-row>

        <!-- -----------------------------------------------
            End Portfolio Text
        ----------------------------------------------- -->
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "PortfolioText",
  data() {
    return {};
  },
  methods: {},
};
</script>
